module.exports = __webpack_public_path__ + "img/net.fc1bd79e.png";